import { cn } from "@/utils/cn";
import { memo } from "react";

// Double 4-point sparkle (matches Figma "AI Icon Container v2" glyph).
const CoachSparkle = () => (
  <svg
    viewBox="0 0 19.3731 19.0001"
    fill="none"
    aria-hidden
    className="h-[22px] w-[22px]"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.2615 10.6798C11.4994 8.89154 8.94119 4.47062 8.44446 2.48368C6.65622 8.24578 1.98693 10.183 0 10.6798C5.7621 12.468 7.94773 17.0131 8.44446 19.0001C10.2327 13.238 15.2745 11.1765 17.2615 10.6798Z"
      fill="white"
    />
    <path
      d="M19.3731 2.95801C17.2175 2.31263 16.2605 0.717109 16.0746 2.1055e-05C15.4056 2.07958 13.6589 2.77874 12.9155 2.95801C15.0712 3.60339 15.8888 5.24373 16.0746 5.96082C16.7436 3.88126 18.6298 3.13728 19.3731 2.95801Z"
      fill="white"
    />
  </svg>
);

interface AppBottomBarCoachButtonProps {
  onClick: () => void;
}

export const AppBottomBarCoachButton = memo(function AppBottomBarCoachButton({
  onClick,
}: AppBottomBarCoachButtonProps) {
  return (
    <button
      type="button"
      className={cn("flex flex-1 flex-col items-center gap-1.5 p-2")}
      onClick={onClick}
      aria-label="Coach"
    >
      {/* Raised above the bar's top edge — the parent row uses items-end so the
          label stays aligned with the other tab labels. */}
      <span
        className={cn(
          "-mt-8 flex h-14 w-14 items-center justify-center rounded-full",
          "bg-gradient-to-tl from-[#43246E] to-[#8C45EE]",
          "active:from-[#43246E] active:to-[#43246E]"
        )}
        style={{boxShadow: "0 0 0px 2px #ffffff5e"}}
      >
        <CoachSparkle />
      </span>
      <span className="text-[11px] leading-[1.1] font-medium text-black">Coach</span>
    </button>
  );
});
